// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

export const countPrice = (price = 0, numberOfLottery = 1, taxPrice = 0) => {
  //taxPrice !== 0 ==> count after tax price
  //taxPrice === 0 ==> count before tax price
  return Math.floor(numberOfLottery * price * (1 + taxPrice / 100));
};
